/* eslint-disable */
/* global aptrinsic */

export default function installGainsightPX(metadata) {
	if (!metadata.userId) {
		// anonymous user - login/help screens
		return;
	}

	let gainsightKey = '';
	switch (metadata.environment) {
		case 'production':
			gainsightKey = 'AP-L1Y4M8CXQJCR-2';
			break;
		case 'beta':
			gainsightKey = 'AP-L1Y4M8CXQJCR-2-2';
			break;
		case 'qa':
			gainsightKey = 'AP-L1Y4M8CXQJCR-2-3';
			break;
		default:
			gainsightKey = 'AP-L1Y4M8CXQJCR-2-4';
			break;
	}

	// Code from Gainsight PX
	(function(n, t, a, e, co) {
		var i = 'aptrinsic';
		(n[i] =
			n[i] ||
			function() {
				(n[i].q = n[i].q || []).push(arguments);
			}),
			(n[i].p = e);
		n[i].c = co;
		var r = t.createElement('script');
		(r.async = !0), (r.src = a + '?a=' + e);
		var c = t.getElementsByTagName('script')[0];
		c.parentNode.insertBefore(r, c);
	})(
		window,
		document,
		'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
		gainsightKey
	);

	aptrinsic(
		'identify',
		{
			//User Fields
			id: metadata.userId, // Required for logged in app users
			email: metadata.userEmail,
			accountId: metadata.orgId,
			// firstName: 'John',
			// lastName: 'Smith',
			// signUpDate: 1522697426479, //unix time in ms
			// plan: 'gold', //Custom attributes - please create those custom attributes in Aptrinsic via Account Settings to be tracked.
			// price: 95.5,
			// userHash: '', // optional transient for HMAC identification
			role: metadata.pendoFAUserRole,
			rptRole: metadata.pendoRPTUserRole,
		},
		{
			//Account Fields
			id: metadata.orgId, //Required
			name: metadata.orgName,
			// Program: 'Platinum', // flat custom attributes
			sfdcId: metadata.salesforceId,
		}
	);
}
